// extracted by mini-css-extract-plugin
export default {"ag-styles":"R_t","alert":"R_d1","info":"R_d2","flag":"R_d3"};